import useAcvDatadog from '@/composables/useAcvDatadog';

export const useHandleErrorCodes = () => {
  const { addRumError } = useAcvDatadog();

  function map400ErrorCodesToPaths(errorCode) {
    switch (errorCode) {
      case 1:
      case 2:
        return '/account-pending';
      case 3:
      case 5:
      case 8:
      case 9:
        return '/403';
      case 4:
        return '/legal';
      case 6:
        return '/signup';
      case 7:
        return '/409';
      case 10:
        // This prevents the check-email page middleware from redirecting back to homepage
        localStorage.removeItem('magic_link_token');
        return '/check-email';
      case 11:
        return '/logout'; // ML token has expired before the MFA token
      default:
        return '/something-went-wrong'; // in the case ML token !== MFA token
    }
  }

  async function handleNavigationByErrorCode(errorCode) {
    const path = map400ErrorCodesToPaths(errorCode);

    if (path) {
      if (path === '/something-went-wrong') {
        const error = new Error(`Unhandled 403 error code`);
        addRumError(error, { errorCode });
      }

      const nuxtApp = useNuxtApp();

      // If <nuxtApp.isHydrating> is true, wait for hydration to complete
      // If hydration is not complete, navigateTo may not work as expected
      if (nuxtApp.isHydrating) {
        await new Promise((resolve) => {
          onNuxtReady(() => resolve());
        });
      }

      return navigateTo(path);
    }
  }

  return { handleNavigationByErrorCode };
};
